import { render, staticRenderFns } from "./FormEmail.vue?vue&type=template&id=40c8b8ba"
import script from "./FormEmail.vue?vue&type=script&lang=js"
export * from "./FormEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports